import React from "react";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";

interface ExpertiseOption {
	id: number;
	name: string;
}

interface ExpertiseSelectProps
	extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
	options: ExpertiseOption[];
}

export const ExpertiseSelect: React.FC<ExpertiseSelectProps> = ({
	label = "Expertise",
	placeholder = "Select expertise",
	options,
	value: valueProp,
	hasError: hasErrorProp,
	errorText: errorTextProp,
	onChange: onChangeProp,
	name,
	...rest
}) => {
	const formik = useFormikFieldState(name);

	const selectOptions: SelectOption[] = options.map((e) => ({
		value: e.id,
		label: e.name,
	}));

	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		formik.markTouched();
		onChangeProp?.(selected);
	};

	return (
		<SelectWithLabel
			options={selectOptions}
			label={label}
			placeholder={placeholder}
			value={valueProp}
			name={name}
			hasError={hasErrorProp || formik.hasError}
			errorText={errorTextProp || formik.errorText}
			onChange={handleChange}
			{...rest}
		/>
	);
};
